/** CHI-23 client helper: fragment-only claim token handling. Pure over a window-like object, so it is unit-tested. */
export const CLAIM_TOKEN_STORAGE_KEY = "chi-ticket-claim";
const TOKEN_RE = /^[A-Za-z0-9_-]{43}$/;

export type ClaimWindowLike = {
  location: { hash: string; pathname: string; search: string };
  history: { replaceState(data: unknown, unused: string, url?: string): void };
  sessionStorage: { getItem(k: string): string | null; setItem(k: string, v: string): void; removeItem(k: string): void };
};

/** Reads #t=<token>, clears the fragment at once, and keeps the token tab-scoped for the sign-in round trip. */
export function readAndClearClaimToken(w: ClaimWindowLike): string | null {
  const m = /(?:^#|&)t=([^&]*)/.exec(w.location.hash || "");
  if (w.location.hash) w.history.replaceState(null, "", w.location.pathname + w.location.search);
  const fromHash = m && TOKEN_RE.test(m[1]) ? m[1] : null;
  try {
    if (fromHash) { w.sessionStorage.setItem(CLAIM_TOKEN_STORAGE_KEY, fromHash); return fromHash; }
    const kept = w.sessionStorage.getItem(CLAIM_TOKEN_STORAGE_KEY);
    return kept && TOKEN_RE.test(kept) ? kept : null;
  } catch {
    return fromHash;
  }
}

export function forgetClaimToken(w: Pick<ClaimWindowLike, "sessionStorage">) {
  try { w.sessionStorage.removeItem(CLAIM_TOKEN_STORAGE_KEY); } catch { /* storage unavailable */ }
}
